"use client";

import { useState } from "react";
import { forumApi, toast } from "@/lib/forum.client";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useForumAuth } from "./useForumAuth";
import { btn } from "./ui";

const field = "w-full rounded-lg border border-gray-200 bg-gray-100 px-2.5 py-2 text-[13px] text-gray-900 outline-none focus:border-[#4451A3]";

const REASONS = ["تبلیغات یا هرزنامه", "محتوای نامناسب", "اطلاعات نادرست", "کلاهبرداری", "سایر"];

type Target = { topic_id?: number; answer_id?: number; ad_id?: number };

export default function ReportBox({ target, label = "گزارش" }: { target: Target; label?: string }) {
    const { guard, handleError } = useForumAuth();
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState(REASONS[0]);
    const [details, setDetails] = useState("");
    const [busy, setBusy] = useState(false);

    const send = async () => {
        if (!guard()) return;
        setBusy(true);
        try {
            const r = await forumApi.report({ ...target, reason, details: details.trim() || undefined });
            toast(r.message);
            setOpen(false);
            setDetails("");
        } catch (e) {
            handleError(e);
        } finally {
            setBusy(false);
        }
    };

    return (
        <span className="relative inline-block">
            <button type="button" className="cursor-pointer p-0 text-[12.5px] text-gray-500 hover:text-[#4451A3] hover:underline" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
                {label}
            </button>
            {open && (
                <span className="absolute left-0 top-full z-20 mt-1.5 flex w-[min(300px,80vw)] flex-col gap-2 rounded-xl border border-gray-200 bg-white p-3 shadow-[0_10px_30px_rgba(20,32,43,.15)] md:left-auto md:right-0">
                    <Select value={reason} onValueChange={setReason}>
                        <SelectTrigger className="h-auto rounded-lg border-gray-200 bg-gray-100 px-2.5 py-2 text-[13px] text-gray-900" aria-label="دلیل گزارش">
                            <SelectValue placeholder="دلیل گزارش" />
                        </SelectTrigger>
                        <SelectContent>
                            {REASONS.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
                        </SelectContent>
                    </Select>
                    <textarea
                        className={`${field} min-h-16 resize-y`}
                        value={details}
                        onChange={(e) => setDetails(e.target.value)}
                        maxLength={2000}
                        placeholder="توضیح بیشتر (اختیاری)"
                        aria-label="توضیح گزارش"
                    />
                    <span className="flex gap-2">
                        <button type="button" className={btn("primary", true)} onClick={send} disabled={busy}>ارسال گزارش</button>
                        <button type="button" className={btn("ghost", true)} onClick={() => setOpen(false)}>انصراف</button>
                    </span>
                </span>
            )}
        </span>
    );
}
